import styled from 'styled-components'
import { heading } from 'styles/typography'
import mq from 'styles/mq'

export const SectionTitle = styled.h1`
  text-align: center;

  ${mq.extraSmall} {
    ${heading.m};
    margin-bottom: 3rem;
  }

  ${mq.small} {
    ${heading.xl};
  }
`

export const SectionSubTitle = styled.h5`
  ${heading.xs};
  text-align: center;
`

export const StarsContainerMobile = styled.div`
  text-align: center;
  margin-bottom: 3rem;

  ${mq.medium} {
    display: none;
  }
`

export const StarsContainerMedium = styled.div`
  text-align: center;
  margin-bottom: 3rem;
  display: none;

  ${mq.medium} {
    display: block;
  }

  ${mq.desktop} {
    display: none;
  }
`

export const StarsContainerDesktop = styled.div`
  text-align: center;
  margin-bottom: 3rem;
  display: none;

  ${mq.desktop} {
    display: block;
  }
`